import Button from "@/components/Button";
import { NowImporting } from "@/components/molecules/NowImporting/NowImporting";
import { useInitImport } from "@/hooks/useInitImport";
import { setIsCurrentlyImporting } from "@/redux/globalState/globalStateSlice";
import { showModal } from "@/redux/message/messageSlice";
import { fetchClubStats } from "@/redux/myClub/myClubSlice";
import { AppDispatch } from "@/redux/store";
import {
  canUseClubImportSelector,
  fetchUserNotifications,
  getUserSelector,
} from "@/redux/user/userSlice";
import { useState } from "react";
import { isSafari } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";

interface StartImportProps {
  disabled: boolean;
  handleClickWhenShouldntImport: () => void;
  shouldntImport: boolean;
  handleImportFinished?: () => void;
}

export const StartImport = ({
  disabled,
  handleClickWhenShouldntImport,
  shouldntImport,
  handleImportFinished,
}: StartImportProps) => {
  const [importStarted, setImportStarted] = useState(false);
  const { user } = useSelector(getUserSelector);
  const canImport = useSelector(canUseClubImportSelector);
  const initImport = useInitImport({ user });
  const fromExtensioniOSApp = !!localStorage.getItem("FROM_EXTENSION_APP");
  const dispatch = useDispatch<AppDispatch>();

  const handleImportStart = () => {
    if (shouldntImport) {
      handleClickWhenShouldntImport();
      return;
    }

    if (!canImport || disabled) {
      dispatch(
        showModal({
          modalType: "premium-feature",
          premiumFeatureHook: "import-club",
        }),
      );
    } else {
      if (isSafari && fromExtensioniOSApp) {
        window.open(
          "https://www.ea.com/ea-sports-fc/ultimate-team/web-app/",
          "_blank",
        );
        setImportStarted(true);
      }
      initImport().then(() => {
        dispatch(setIsCurrentlyImporting(true));
        if (!isSafari || !fromExtensioniOSApp) {
          window.open(
            "https://www.ea.com/ea-sports-fc/ultimate-team/web-app/",
            "_blank",
          );
          setTimeout(() => {
            setImportStarted(true);
          }, 1000);
        }
      });
    }
  };

  const finishedImport = () => {
    setImportStarted(false);
    dispatch(fetchUserNotifications());
    dispatch(fetchClubStats());
    handleImportFinished?.();
  };

  return (
    <>
      {canImport && (
        <Button
          label={
            <span className="text-sm font-medium flex flex-row gap-x-1">
              <span>Import</span>
              <span className="hidden mobile:block">Club</span>
            </span>
          }
          onClick={(e) => {
            e.stopPropagation();
            handleImportStart();
          }}
          variant={disabled ? "disabled" : "primary"}
        />
      )}
      {importStarted && (
        <NowImporting
          onClickDone={finishedImport}
          onClickCancel={() => setImportStarted(false)}
        />
      )}
    </>
  );
};
